import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .bar-zone {
    display: flex;

    @media (max-width: 767px) {
      display: block;
    }

    & .input {
      width: 735px;
      padding-right: 30px;

      @media (max-width: 767px) {
        width: 100%;
        padding-right: 0;
      }
    }

    & .buttonZone {
      padding-top: 15px;
    }
  }

  .separator {
    color: ${colors.graySix};
    font-size: 16px;
    font-family: 'Roboto Condensed';
    font-weight: 700;
    line-height: 19px;
    border-bottom: 1px solid ${colors.graySeven};
    padding-bottom: 5px;
    margin-bottom: 17px;
    margin-top: 13px;
    text-transform: uppercase;
  }

  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    &--queryless {
      margin: 100px 0;
    }

    &-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1500px;
      padding: 0 15px;

      &__title {
        margin: 0 0 32px 0;
        font-weight: 500;
      }

      &__search {
        display: flex;
        gap: 10px;
        width: 100%;

        &__select {
          padding: 0 50px 0 10px;
          height: 40px;
          cursor: pointer;
          background: white;
          border: 1px solid #b3b3b3;
          border-radius: 5px;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-color: #fff;
          background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"/></svg>');
          background-repeat: no-repeat;
          background-position: right 10px center;
          background-size: 20px;
        }

        &__bar {
          display: flex;
          position: relative;
          width: 100%;

          &__input {
            padding: 10px;
            flex: 1;
            background: white;
            border: 1px solid #b3b3b3;
            border-radius: 5px;
          }

          &__button {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 7px;
            top: 9px;
            padding-left: 10px;
            border: none;
            border-left: 1px solid #b3b3b3;
            height: max-content;
            background: none;
            cursor: pointer;

            &:hover .main-container__search__bar__button__icon {
              opacity: 1;
            }

            &__icon {
              height: 20px;
              width: 20px;
              opacity: 0.5;
              transition: all 300ms;
            }
          }
        }

        &__link {
          width: fit-content;
          text-decoration: underline;
          text-align: left;
          color: #262626;
          background: none;
          border: none;
          padding: 0;
          white-space: nowrap;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            color: black;
          }
        }
      }

      &__bottom {
        display: flex;
        flex-direction: column;
        margin-top: 8px;

        &__filters {
          display: flex;
          gap: 8px;
          margin-bottom: 8px;

          &__clear {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 8px;
            height: 40px;
            background: none;
            border: none;
            border-radius: 5px;
            white-space: nowrap;
            cursor: pointer;
            transition: all 300ms;

            &:hover {
              background-color: #f0f0f0;
            }
          }
        }

        &__fields {
          display: flex;
          align-items: center;
          gap: 8px;
          overflow-x: auto;

          &__item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            height: 40px;
            background: white;
            border: 1px solid #b3b3b3;
            border-radius: 5px;
            white-space: nowrap;

            &__remove {
              border: none;
              background: none;
              padding: 0;
              opacity: 0.5;
              cursor: pointer;
              transition: all 300ms;

              &:hover {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }
`;

const svgStyle = {
  width: 20
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/SearchBar/style.js